/**
 * Determine the locale for displaying the date.
 * The order of priorities is:
 * 1. If locale is provided directly via argument.
 * 2. If the user has a preference configured.
 * 3. The default locale the browser is configured to.
 *
 * @param definedLocale Locale defined by consuming location.
 *
 * @return Locale to be used for display.
 */
export const computeLocale = function(definedLocale?: string): string {
  const definedIsUsable = definedLocale !== undefined &&
    typeof definedLocale === 'string' &&
    definedLocale.length > 1;

  if (definedIsUsable) {
    return definedLocale;
  }

  const preferredLocale = localStorage.getItem(
      'dnb.preferences.locale',
  );

  if (preferredLocale !== null) {
    return preferredLocale;
  }

  return navigator.languages[0];
};
